import { render, staticRenderFns } from "./rules-overrides.vue?vue&type=template&id=7a3fd71a&scoped=true&lang=pug&"
import script from "./rules-overrides.vue?vue&type=script&lang=ts&"
export * from "./rules-overrides.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3fd71a",
  null
  
)

export default component.exports